var map = {
	"./img-1.png": 57600,
	"./img-2.png": 21308,
	"./img-3.png": 27986,
	"./img-4.png": 30812,
	"./img-5.png": 44109,
	"./img-6.png": 85967,
	"./img-7.png": 5790
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71104;